<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'app'
    }
</script>

<style>
    body, html {
        padding: 0;
        width: 100%;
    }

    html {
        background-color: #E4E9EE;
    }

    body {
        margin: 0 auto;
        background-color: #FFF;
    }

    ui, li {
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    input {
        -webkit-tap-highlight-color: transparent;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue